import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/blanks";
import validateForm from "../../lib/helpers/validateForm";
import { fioLitleTruncateFromObject } from "../../lib/helpers/strings";
import { getDateFormat } from "../../lib/helpers/dates";
import {
  getStatusBlankString,
  getFioAddFromGiveToLittleTruncate,
  getTitleAddOrGive
} from "../../lib/helpers/blanks";

// UI
import {
  Alerts,
  Box,
  Button,
  Input,
  Header,
  HeaderPage,
  Row,
  Col,
  ButtonGroup
} from "../../ui";

class BlankEditPage extends Component {
  state = {
    titleHeader: "Изменение кассового ордера",
    blank: {},
    form: {
      blank_number: {
        value: "",
        isEdited: false,
        isError: false,
        errors: []
      },
      bilet_id: { value: "", isEdited: false, isError: false, errors: [] },
      filial_id: { value: "", isEdited: false, isError: false, errors: [] },
      user_id: { value: "", isEdited: false, isError: false, errors: [] },
      sum: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.sum
      },
      reason: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.reason
      },
      created_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.created_at
      },
      updated_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.updated_at
      }
    },
    buttons: {
      save: {
        disabled: false,
        title: "Изменить ордер"
      }
    },
    redirect: {
      is: false,
      link: ""
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const blank = await API.blanks.getOne(id);

    if (blank && blank.blank_number) {
      const { form, redirect } = this.state;

      // Формируем redirect
      redirect.link = `/blanks/${id}`;

      // Заполняем форму
      for (let key in form) {
        // Если филиал
        if (key === "filial_id") {
          form[key].value = blank[key].name;
        } else if (key === "bilet_id") {
          if (blank[key] && blank[key].bilet_number) {
            form[key].value = blank[key].bilet_number;
          } else {
            delete form[key];
          }
        } else if (key === "user_id") {
          form[key].value = fioLitleTruncateFromObject(blank[key]);
        } else {
          if (form[key].isNumber) {
            form[key].value = String(blank[key]) || "0";
          } else if (form[key].isDate) {
            form[key].value = getDateFormat(blank[key]);
          } else {
            form[key].value = blank[key] || "";
          }
        }
      }

      this.setState({ blank, form, redirect });
    }
  }

  handleInput = (e, fromDatePicker) => {
    let value = e.target.value;
    let name = e.target.name;

    if (fromDatePicker && fromDatePicker.value) {
      value = fromDatePicker.value;
    }

    const { form } = this.state;

    console.log("handleInput in page:", e, value, name);

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      const { save } = this.state.buttons;
      save.disabled = true;

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, save },
          loading: true
        };
      });

      save.disabled = false;

      const { form } = this.state;
      const { id } = this.props.match.params;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const resultUpdated = await API.blanks.editOne(id, {
          ...optionsRequest
        });

        if (resultUpdated) {
          Alerts.success("Ордер изменён");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("Ордер не изменён");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });

          this.props.history.goBack();
        }
      } else {
        Alerts.alert("В ордере нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: { ...prevState.buttons, save }
          };
        });

        this.props.history.goBack();
      }
    }
  };

  render() {
    const { blank, form } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <HeaderPage
            title={this.state.titleHeader + " №" + form.blank_number.value}
            back={this.props.history.goBack}
          >
            <ButtonGroup>
              <Button
                type="submit"
                theme="success"
                disabled={this.state.buttons.save.disabled}
              >
                {this.state.buttons.save.title}
              </Button>
              <Button
                type="button"
                onClick={() => this.props.history.goBack()}
                theme="default"
              >
                Отмена
              </Button>
            </ButtonGroup>
          </HeaderPage>

          <Box>
            <Header size={2} margin="no-top">
              Изменение текущего состояния
            </Header>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Input
                  label="Номер к/о:"
                  name="blank_number"
                  value={this.state.form.blank_number.value}
                  disabled={true}
                />
                <Input
                  label="Филиал:"
                  name="filial_id"
                  value={this.state.form.filial_id.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Операция
                </Header>

                <Input
                  label="Тип:"
                  name="blank_type"
                  value={getStatusBlankString(blank.blank_type)}
                  disabled={true}
                />
                <Input
                  label="Основание:"
                  name="reason"
                  value={this.state.form.reason.value}
                  errors={this.state.form.reason.errors}
                  handleChange={this.handleInput}
                />
                {!!blank.bilet_id ? (
                  <Input
                    label="Залоговый билет:"
                    name="bilet_id"
                    value={this.state.form.bilet_id.value}
                    disabled={true}
                  />
                ) : null}
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Деньги
                </Header>

                <Input
                  label="Сумма:"
                  type="number"
                  name="sum"
                  value={this.state.form.sum.value}
                  errors={this.state.form.sum.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Люди
                </Header>

                <Input
                  label={`${getTitleAddOrGive(blank)}:`}
                  name="add_from_or_give_to"
                  value={getFioAddFromGiveToLittleTruncate(blank)}
                  disabled={true}
                />
                <Input
                  label="Ответсвенный:"
                  name="user_id"
                  value={this.state.form.user_id.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-right">
                <Header size={5} margin="no-top">
                  Изменения
                </Header>

                <Input
                  label="Дата создания к/о:"
                  name="created_at"
                  type="date"
                  dateRight={true}
                  value={this.state.form.created_at.value}
                  errors={this.state.form.created_at.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Дата обновления к/о:"
                  name="updated_at"
                  type="date"
                  dateRight={true}
                  value={this.state.form.updated_at.value}
                  errors={this.state.form.updated_at.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
              </Col>
            </Row>
          </Box>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(BlankEditPage));
